import { FloatingHelper } from 'wix-style-react';
import React from 'react';
import { composer } from '../../../../../component-decorators/composer';
import { isWixApp, wixChatBotLink } from '../../../../../common/utils';
export var BlockReviewsHelper = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, app = _a.app, opened = _a.opened, target = _a.target;
    var getActionText = function () {
        var _a, _b;
        return isWixApp((_b = (_a = app === null || app === void 0 ? void 0 : app.company) === null || _a === void 0 ? void 0 : _a.companyBase) === null || _b === void 0 ? void 0 : _b.id)
            ? t('solution.page.reviews.block-helper-cta2')
            : t('solution.page.reviews.block-helper-cta1');
    };
    var getContent = function () {
        var _a, _b;
        return isWixApp((_b = (_a = app === null || app === void 0 ? void 0 : app.company) === null || _a === void 0 ? void 0 : _a.companyBase) === null || _b === void 0 ? void 0 : _b.id)
            ? t('solution.page.reviews.block-helper-description-wix', {
                appName: app === null || app === void 0 ? void 0 : app.baseInfo.name,
            })
            : t('solution.page.reviews.block-helper-description', {
                appName: app === null || app === void 0 ? void 0 : app.baseInfo.name,
            });
    };
    var onActionClick = function () {
        var _a, _b;
        if (isWixApp((_b = (_a = app === null || app === void 0 ? void 0 : app.company) === null || _a === void 0 ? void 0 : _a.companyBase) === null || _b === void 0 ? void 0 : _b.id) && window) {
            window.open(wixChatBotLink);
        }
        else if (window) {
            var supportMails = app === null || app === void 0 ? void 0 : app.supportEmails.join(';');
            window.location.href = 'mailto:' + supportMails;
        }
    };
    return (React.createElement(FloatingHelper, { target: t(target), content: React.createElement(FloatingHelper.Content, { title: t('solution.page.reviews.block-helper-title'), body: getContent(), actionText: getActionText(), onActionClick: function () { return onActionClick(); }, actionTheme: 'standard' }), zIndex: 1456, opened: opened, placement: "top-end", appearance: 'light' }));
});
//# sourceMappingURL=block-reviews-helper.js.map